// Onda 2 (2026-06-02): migrado pra Antd. Table + Tag + Button antd; remove HTML table custom.
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table, Button, Tag, Space, Empty, Spin, Typography, App as AntApp, Popconfirm,
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { ApartmentOutlined, DeleteOutlined } from '@ant-design/icons';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import { fmt } from './utils';

export function AbaComposicoes({ negocioId, onNova, onAbrir, reloadFlag }: {
  negocioId: number; onNova: () => void; onAbrir: (id: string) => void; reloadFlag: number;
}) {
  const { message } = AntApp.useApp();
  const [comps, setComps] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { carregar(); }, [negocioId, reloadFlag]);
  async function carregar() {
    setLoading(true);
    try {
      const token = await getToken();
      const res = await axios.get(`${API_URL}/comercial/composicoes?proposta_id=${negocioId}`,
        { headers: { Authorization: token } });
      const data = res.data?.body ? JSON.parse(res.data.body) : res.data;
      setComps(Array.isArray(data) ? data : []);
    } finally { setLoading(false); }
  }
  async function excluirComposicao(id: string, nome: string) {
    try {
      const token = await getToken();
      await axios.delete(`${API_URL}/comercial/composicoes/${id}`,
        { headers: { Authorization: token } });
      message.success(`Composição "${nome}" excluída`);
      await carregar();
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.message));
    }
  }

  const columns: ColumnsType<any> = [
    { title: 'Nome', dataIndex: 'nome', key: 'nome',
      ellipsis: { showTitle: false },
      render: (v, c) => (
        <a onClick={() => onAbrir(c.id)} title={v}
          style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', maxWidth: '100%' }}>
          {v}
        </a>
      ) },
    { title: 'Custo', dataIndex: 'total_custo', key: 'custo', align: 'right', width: 120,
      render: (v) => <span style={{ color: '#cf1322' }}>{fmt(v)}</span> },
    { title: 'Venda', dataIndex: 'total_venda', key: 'venda', align: 'right', width: 120,
      render: (v) => <strong>{fmt(v)}</strong> },
    { title: 'Itens', dataIndex: 'n_itens', key: 'itens', align: 'center', width: 70 },
    { title: 'Status', dataIndex: 'status', key: 'status', align: 'center', width: 100,
      render: (v) => <Tag>{v}</Tag> },
    { title: 'Ações', key: 'acoes', align: 'center', width: 70,
      render: (_, c) => (
        <Popconfirm title={`Excluir "${c.nome}"?`} okText="Excluir" okType="danger" cancelText="Cancelar"
          onConfirm={() => excluirComposicao(c.id, c.nome)}>
          <Button danger size="small" icon={<DeleteOutlined />} title="Excluir composição" />
        </Popconfirm>
      ) },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 12, width: '100%', justifyContent: 'space-between' }}>
        <Typography.Text strong style={{ color: '#020D7F' }}>
          {comps.length} composição{comps.length === 1 ? '' : 'ões'}
        </Typography.Text>
        <Button type="primary" icon={<ApartmentOutlined />} onClick={onNova}>
          Nova composição
        </Button>
      </Space>
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center' }}><Spin /></div>
      ) : comps.length === 0 ? (
        <Empty description="Nenhuma composição neste negócio" />
      ) : (
        <Table rowKey="id" columns={columns} dataSource={comps} pagination={false}
          size="small" tableLayout="fixed" />
      )}
    </div>
  );
}
